export const HALF_HOUR_SEC = 1800;
export const ONE_MIN_SEC = 60;

export const MAX_WIDTH_FOR_MOBILE = 480;
